import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { Button, Grid } from "@material-ui/core";
import classNames from "classnames";
import qs from "query-string";

const useStyles = makeStyles(theme =>
  createStyles({
    root: {},
    content: {
      color: theme.palette.common.grey[500],
    },
    button: theme.typography.subtitle2,
    default: {
      color: "inherit",
    },
    active: {
      color: "black",
    },
  }),
);

const VideoListSortingButton = props => {
  const classes = useStyles();

  const { isSearch = false } = props;
  const { sort_key } = qs.parse(props.location.search);
  const getTypes = isSearch => {
    if (isSearch) {
      const types = ["最高相關", "最多觀看", "最新影片"];
      const sort_keys = ["relevant", "played", "created_at"];
      return [types, sort_keys];
    }
    const types = ["最多觀看", "最新影片"];
    const sort_keys = ["played", "created_at"];
    return [types, sort_keys];
  };

  const [types, sort_keys] = getTypes(isSearch);

  const [typeState, setTypeState] = useState(0);

  useEffect(() => {
    if (sort_key) {
      const index = sort_keys.indexOf(sort_key);
      if (index !== -1) {
        setTypeState(index);
      }
    } else {
      setTypeState(0);
    }
  }, [sort_key]);

  return (
    <>
      <div className={classes.root}>
        <div className={classes.content}>
          <Grid container justify='center' alignItems='center'>
            {types.map((type, idx) => (
              <Grid item key={`sort-${type}`}>
                <Button
                  onClick={() => {
                    setTypeState(idx);
                    const searchString = qs.stringify({
                      ...qs.parse(props.location.search),
                      sort_key: sort_keys[idx],
                    });
                    props.history.push({
                      pathname: props.location.pathname,
                      search: searchString,
                    });
                  }}
                  className={classNames(classes.button, classes.default, {
                    [classes.active]: typeState === idx,
                  })}
                >
                  {type}
                </Button>
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
    </>
  );
};

VideoListSortingButton.defaultProps = {};

VideoListSortingButton.propsTypes = {};

export default withRouter(VideoListSortingButton);
